const baseURL = process.env.REACT_APP_BASE_URL;
const apiURL = process.env.REACT_APP_API_URL;

export const urlBase = baseURL;
export const urlActualizarUser = `${apiURL}/actualizarDatos`;
export const urlSubirExceles = `${apiURL}/addExcel`;
export const urlTransformToCsv = `${apiURL}/transformToCsv`;
export const urlConstruirJsons = `${apiURL}/construirJsons`;
export const urlInsertJsons = `${apiURL}/addSeries`;
export const urlObtenerLogsSerials = `${apiURL}/obtenerLogSerials`;
export const urlObtenerDetallesLogSerial = `${apiURL}/obtenerDetallesLogSerial`;
export const urlGenerarExcel = `${apiURL}/generarExcel`;
export const urlUpdateSeries = `${apiURL}/series`;